require("bootstrap");
import "../../stylesheets/information/plans.scss";
import "../../stylesheets/donando_cl.scss";
import { formatPhoneNumber, loadPhoneNumber } from "../backoffice/utils";

$(document).ready(function () {
  let data = {
    name: "",
    last_name: "",
    account_name: "",
    email: "",
    phone_number: "",
    selection: [],
  };
  loadPhoneNumber()
  window.onscroll = function () {
    setScrollClass();
  };
  var calculator = document.getElementById("calculator");
  var sticky = calculator.offsetTop;

  function setScrollClass() {
    if (window.pageYOffset >= sticky) {
      calculator.classList.add("sticky");
    } else {
      calculator.classList.remove("sticky");
    }
  }
  function unCheckButtons(selector) {
    $(`.checked.${selector}`).each((index, button) => {
      var setupFee = Number(button.dataset["setupFee"]);
      var supportFee = Number(button.dataset["supportFee"]);
      var paymentCommission = Number(button.dataset["paymentCommission"]);
      var initialSetupFee = document.getElementById("setup-fee");
      var initialSupportFee = document.getElementById("support-fee");
      var initialPaymentCommission =
        document.getElementById("payment-commission");
      button.classList.remove("checked");
      initialSetupFee.innerHTML = Number(initialSetupFee.innerHTML) - setupFee;
      initialSupportFee.innerHTML =
        (Number(initialSupportFee.innerHTML) - supportFee).toPrecision(2);
      if (paymentCommission) {
        initialPaymentCommission.innerHTML = "7";
      }
    });
  }
  $(".check-button").on("click", function (event) {
    var button = event.currentTarget;
    var setupFee = Number(button.dataset["setupFee"]);
    var supportFee = Number(button.dataset["supportFee"]);
    var paymentCommission = Number(button.dataset["paymentCommission"]);
    var selector = button.dataset["type"];
    var initialSetupFee = document.getElementById("setup-fee");
    var initialSupportFee = document.getElementById("support-fee");
    var initialPaymentCommission =
      document.getElementById("payment-commission");
    const selection_name = button.dataset["name"];
    if (button.classList.contains("checked")) {
      button.classList.remove("checked");
      data["selection"].pop(selection_name);
      initialSetupFee.innerHTML = Number(initialSetupFee.innerHTML) - setupFee;
      initialSupportFee.innerHTML =
        (Number(initialSupportFee.innerHTML) - supportFee).toPrecision(2);
      if (paymentCommission) {
        initialPaymentCommission.innerHTML = "7";
      }
    } else {
      unCheckButtons(selector);
      button.classList.add("checked");
      if (!data["selection"].includes(selection_name)) {
        data["selection"].push(selection_name);
      }
      initialSetupFee.innerHTML = Number(initialSetupFee.innerHTML) + setupFee;
      initialSupportFee.innerHTML =
        Number(initialSupportFee.innerHTML) + supportFee;
      if (paymentCommission) {
        initialPaymentCommission.innerHTML = paymentCommission;
      }
    }
  });
  $(".form-control").on("blur", function (event) {
    if (event.target.id == 'phone_number_hidden_input') {
      formatPhoneNumber();
      let phone_field = $('#phone-number')[0]
      data[phone_field.name] = phone_field.value;
    } else {
      data[event.target.name] = event.target.value;
    }
  });

  $("#calendly-calendar").on("click", function (e) {
    $.ajax({
      type: "POST",
      beforeSend: function (xhr) {
        xhr.setRequestHeader(
          "X-CSRF-Token",
          $('meta[name="csrf-token"]').attr("content")
        );
      },
      url: "/save_contact/donando_plans",
      data: data,
    }).done(function (response) {
      $("#contact_id").val(response["id"]);
    });
    Calendly.initPopupWidget({
      url: "https://calendly.com/cecilia-errazuriz-donando/reunion-donando",
      prefill: {
        name: `${data["name"]} ${data["last_name"]}`,
        email: data["email"],
        customAnswers: {
          a1: data["account_name"],
          a3: meeting_message(),
        },
      },
    });
    return false;
  });

  function meeting_message() {
    var msg = ''
    const formatter = new Intl.ListFormat("es", {
      style: "long",
      type: "conjunction",
    });
    if (data["selection"].length > 0) {
      msg = `Me gustaría cotizar ${formatter.format(data["selection"])}.`;
    } else {
      msg = `Quisiera tener más información de Donando Starter.`;
    }
    return `¡Hola Donando!\n${msg}`;
  }
});
